module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_shinsa-082da5a5d6e0a40a2916060ddedc238e.png";